import { render, staticRenderFns } from "./cosponsors.vue?vue&type=template&id=a80e4d64&"
import script from "./cosponsors.vue?vue&type=script&lang=js&"
export * from "./cosponsors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports